import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ApiResource } from '../../resources/api.resource';
import { NgForm } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

declare var $:any;
declare var window: any;
// declare var captchaRef:any;



@Component({
  selector: 'tabs-component',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.css'],
  providers: [DatePipe]
})
export class TabsComponent implements OnInit {

  public myDate = new Date();
  
  @Input('tabsHtml')tabsHtml;
  @Input('responseUuid')responseUuid;

  @Output() uuid: EventEmitter<any> = new EventEmitter();

  public form_data:any;

  public form_datos = { 
    producto:'',  
    ingresos: '',
    trabajo: '',
    ocupacion: '',
    experiencia_crediticia: '',
    horas_habiles: '-',
    tipoDocumento: '',
    numeroDocumento: '',
    nombre: '',
    primerApellido: '',
    segundoApellido: '',
    departamento: '',
    numeroCelular: '',
    telefono: '',
    correo: '',
    tipoSolicitud:'2',
    tipoCorreo:'0'

  }

  activeTabIndex: number = 0;
  selectedTabIndex: string = '#tab-item-0'; 

  // Cambiar tab desde los enlaces
  cambiarTab(indice: number, event?: Event) {
    if (event) {
      event.preventDefault();
    }
    this.activeTabIndex = indice;
    this.selectedTabIndex = indice.toString();
  }

  // Cambiar tab desde el select
  onTabChange(event: any) {
    const indice = parseInt(event.target.value.split('-')[2]); // Extraer número de "#tab-item-2"
    this.activeTabIndex = indice;
  }


  constructor(private resource: ApiResource,private rutaActiva: ActivatedRoute, private datePipe: DatePipe,private sanitizer: DomSanitizer) {
    // this.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
   }

  private leerParametrosURL(): void {
    // Query parameters (?param=value&otro=valor)
    this.rutaActiva.queryParams.subscribe(params => {
      console.log('Query parameters recibidos:', params);

      this.cambiarTab(1);
      this.selectedTabIndex = '#tab-item-1';

      if (params['pdf']) {
         setTimeout(() => {
          const $modal =  $(`#${params['pdf']}`);
          $modal.modal('show');
        }, 1000);
        console.log('Mostrando modal con ID:', params['pdf']);
      }
    });
  }

  ngOnInit() {  

    if(this.tabsHtml.html === '<p></p>'){
      this.tabsHtml.html = '';
    }

    if(this.tabsHtml.html_i === '<p></p>'){
      this.tabsHtml.html_i = '';
    }

    this.readLocalStorageValue('idiomaEspañol');

    if( localStorage.getItem("idiomaEspañol")== 'true' || localStorage.getItem("idiomaEspañol")== 'true' ){

}else{
  localStorage.setItem("idiomaEspañol","false");
}

if (this.tabsHtml && this.tabsHtml.tabs) {
  this.tabsHtml.tabs = this.tabsHtml.tabs.map((tab: any) => {
    return {
      ...tab,
      html: this.sanitizer.bypassSecurityTrustHtml(tab.html)
    };
  });
}

if (this.tabsHtml && this.tabsHtml.tabs) {
  this.tabsHtml.tabs = this.tabsHtml.tabs.map((tab: any) => {
    return {
      ...tab,
      html_i: this.sanitizer.bypassSecurityTrustHtml(tab.html_i)
    };
  });
}

    this.cambiarTab(0);
    this.selectedTabIndex = '#tab-item-0';
    this.leerParametrosURL();

  }

  redireccionarAPaginaExistente(uuid){
    
    this.uuid.emit(uuid);
    $(".lg-menu").fadeOut();
  }

  onlyNumbers(event) {
    let keyCode = event['keyCode'] || 0;
    if (keyCode < 48 || keyCode > 57) {
      event.preventDefault();
    }
  }

  toggleModal(isLast = false) {
    let modalForm = $('#tabs');

    if (modalForm.hasClass('active')) {
      $('body').removeClass('overflow-hidden');
    } else {
      $('body').addClass('overflow-hidden');
    }

    modalForm.toggleClass('active');

    if (isLast) {
      this.showModal(1);
    }
    this.leerParametrosURL();

  }

  showModal(id) {
    const $modal = $('.modal-act-wrapper');
    const $msg = $modal.find('.title');

    const $inp = (name = '', isRadio = false) => {
      return $(`[name="product-sup-${name}"]${isRadio ? ':checked' : ''}`).val();
    };

    $('.page-modal .modal').removeClass('active');

    const producto = $inp('producto');
    const ingresos = $inp('ingresos');
    const ocupacion = $inp('ocupacion');
    const experiencia = $inp('exp_crediticia');
    const tipoDocumento = $inp('tipo-doc');
    const numeroDocumento = $inp('numero-documento');
    const nombre = $inp('nombre');
    const primerApellido = $inp('primer-apellido');
    const segundoApellido = $inp('segundo-apellido');
    const departamentos = $inp('departamentos');
    const numeroCelular = $inp('numero-celular');
    const telefono = $inp('telefono');
    const correo = $inp('correo');
    const terminos = $('[name="product-sup-terminos"]')[0].checked ? 'Acepto términos' : 'No acepto términos';

    const validations = [];

    if (id === 2) {
      // l('Current step 1');
      if (ingresos == '-') { validations.push(1); }
      if (ocupacion == '-') { validations.push(1); }
      console.log(ocupacion)
      
    }

    if (id === 3) {
      if (!tipoDocumento) { validations.push(1); }
      if (numeroDocumento === '') { validations.push(1); }
      if (nombre === '') { validations.push(1); }
      
      if (primerApellido === '') { validations.push(1); }
      if (segundoApellido === '') { validations.push(1); }
    }

    if (id === 4) {
      if (departamentos === '') { validations.push(1); }
      if (numeroCelular === '') { validations.push(1); }
      // if (telefono === '') { validations.push(1); }
      if (correo === '') { validations.push(1); }
    }

    if (validations.length === 0) {
      if (id === 4) {
        let data = {};
        const getInfo = () => data;

        if (producto) { data = { ...data, producto }; }
        if (ingresos) { data = { ...data, ingresos }; }
        if (ocupacion) { data = { ...data, ocupacion }; }
        if (tipoDocumento) { data = { ...data, tipoDocumento }; }
        if (numeroDocumento) { data = { ...data, numeroDocumento }; }
        if (nombre) { data = { ...data, nombre }; }
       
        if (primerApellido) { data = { ...data, primerApellido }; }
        if (segundoApellido) { data = { ...data, segundoApellido }; }
        if (departamentos) { data = { ...data, departamentos }; }
        if (numeroCelular) { data = { ...data, numeroCelular }; }
        if (telefono) { data = { ...data, telefono }; }
        if (correo) { data = { ...data, correo }; }
        if (terminos) { data = { ...data, terminos }; }

/*var horas_habiles=this.form_datos.h_habiles;
console.log(this.form_datos.h_habiles);
data = { ...data, horas_habiles};

var experiencia_crediticia=this.form_datos.exp_crediticia;
console.log(experiencia_crediticia);
data = { ...data, experiencia_crediticia};
var tipoCorreo=this.form_datos.tipoCorreo;
data = { ...data,tipoCorreo };
var tipoCorreo=this.form_datos.tipoCorreo;
data = { ...data,tipoCorreo };
var tipoSolicitud=this.form_datos.tipoSolicitud;
data = { ...data,tipoSolicitud };
*/


        const $btnAct = $('.btn-action-trgr');
        const btnActText = $btnAct.val();
        // $btnAct.attr('disabled', true).val('Enviando datos...');
        
        console.log(data);

        this.form_data=data;
        // this.enviarCorreo(data);
        
        

        event.preventDefault();
        // grecaptcha.execute();
      //  window['grecaptcha'].execute();
      grecaptcha.execute();
      } else {
        $('.page-modal .modal-'+id).addClass('active');
      }
    } else {
      $msg.text('Debes completar todos los campos');
      $(`.page-modal .modal.modal-${id - 1}`).addClass('active');

      $modal.addClass('active');
    }
    
  }


  rcEvent(captchaResponse) {
    if (captchaResponse) {
      this.enviarCorreoElectronico();
      //this.postDatCrediPersonal();
    }
  }

  enviarCorreoElectronico(){

    // console.warn(this.form_data);
    // console.log("mi fecha" + this.myDate);
    // this.resource.DatCrediPersonal(this.form_datos).subscribe(resp=>{
    //   if(resp.response=='Success.'){
        
    //    console.log('success '+resp.data);
    //    console.log('success '+this.form_data);

    //   }
    //   else{
    //     console.log('fail '+resp.data);
    //   }
    // },
    // err=>{
    //   console.log('error');
    // }
    // );
    // console.warn(this.form_datos);
    // this.postDatCrediPersonal();

    //console.warn(this.responseUuid.details.email || this.responseUuid.configuration.general_email)
//this.form_datos.producto='Prod';
//this.form_datos.ingresos='800';
    let data={
      form_data:this.form_datos,
      to:'',
      form_name:`Davivienda Formulario de solicitud de producto -  ${this.tabsHtml.nombre}`
    };

    this.resource.sendEmail(data).subscribe(resp=>{
      if(resp.response=='Success.'){

        let $modal = $('.modal-act-wrapper');
        let $msg = $modal.find('.title');
        let hideModal = () => {
          setTimeout(() => {
            $modal.removeClass('active');
          }, 3000);
        };
        $msg.text('Solicitud enviada con exito.');
        $modal.addClass('active');
        window.grecaptcha.reset();
        hideModal();

this.form_datos.producto='';
        this.form_datos.ingresos=null;
        this.form_datos.trabajo=null;
        this.form_datos.ocupacion=null;
        this.form_datos.experiencia_crediticia=null;
        this.form_datos.horas_habiles=null;
        this.form_datos.tipoDocumento=null;
        this.form_datos.numeroDocumento=null;
        this.form_datos.nombre=null;
        this.form_datos.primerApellido=null;
        this.form_datos.segundoApellido=null;
        this.form_datos.numeroCelular=null;
        this.form_datos.telefono=null;
        this.form_datos.correo=null;
        this.form_datos.departamento=null;

        this.form_data.email=null;
        this.form_data.nombre=null;
        this.form_data.telefono=null;

        this.toggleModal(true);



      }
      else{


        this.form_datos.producto='';
        this.form_datos.ingresos=null;
        this.form_datos.trabajo=null;
        this.form_datos.ocupacion=null;
        this.form_datos.experiencia_crediticia=null;
        this.form_datos.horas_habiles=null;
        this.form_datos.tipoDocumento=null;
        this.form_datos.numeroDocumento=null;
        this.form_datos.nombre=null;
        this.form_datos.primerApellido=null;
        this.form_datos.segundoApellido=null;
        this.form_datos.numeroCelular=null;
        this.form_datos.telefono=null;
        this.form_datos.correo=null;

        this.form_data.email=null;
        this.form_data.nombre=null;
        this.form_data.telefono=null;

        let $modal = $('.modal-act-wrapper');
        let $msg = $modal.find('.title');
        let hideModal = () => {
          setTimeout(() => {
            $modal.removeClass('active');
          }, 3000);
        };
        $msg.text('No se pudo procesar la solicitud.');
        $modal.addClass('active');
        window.grecaptcha.reset();
        hideModal();
      }
    },
    err=>{

this.form_datos.producto='';
        this.form_datos.ingresos=null;
        this.form_datos.trabajo=null;
        this.form_datos.ocupacion=null;
        this.form_datos.experiencia_crediticia=null;
        this.form_datos.horas_habiles=null;
        this.form_datos.tipoDocumento=null;
        this.form_datos.numeroDocumento=null;
        this.form_datos.nombre=null;
        this.form_datos.primerApellido=null;
        this.form_datos.segundoApellido=null;
        this.form_datos.numeroCelular=null;
        this.form_datos.telefono=null;
        this.form_datos.correo=null;

      this.form_data.email=null;
        this.form_data.nombre=null;
        this.form_data.telefono=null;

        let $modal = $('.modal-act-wrapper');
        let $msg = $modal.find('.title');
        let hideModal = () => {
          setTimeout(() => {
            $modal.removeClass('active');
          }, 3000);
        };
        $msg.text('No se pudo procesar la solicitud.');
        $modal.addClass('active');
        window.grecaptcha.reset();
        hideModal();
    }
    );
  }

 

  // public guardar(postForm: NgForm) {
  //   try {
  //     if (this.postForm.valid) {
  //       // debugger;
  //       if (postForm.value.nuevaClave == postForm.value.nuevaClave2) {
  //         this.cargando = true;
  //         let data = {
  //           idCredenciales: null,
  //           tipoServicio: "VALIDACION_USUARIOS",
  //           buro: {
  //             idBuro: postForm.value.gidBuro
  //           },
  //           nombreUsuario: postForm.value.gusuario,
  //           claveAntigua: postForm.value.gclaveAnterior,
  //           contrasenia: postForm.value.gnuevaClave,
  //           confContrasenia: postForm.value.gnuevaClave2,
  //           usuarioMod: localStorage.getItem("idUsuarioMtto"),
  //           evento : this.tipoModificacion,
  //         };
  //         let termino = "/credencialesBuroExterno";
  //         this.pdService.postData(termino, data).subscribe(resp => {
  //           if (resp.estado == 'SUCCESS') {
  //             this.obtenerListaDeCredencialesDeBuroExterno();
  //             this._notify.success('¡Éxito!', 'Registro agregado.');
  //             this.postForm.reset();
  //             $(".modal").modal("hide");
  //             this.cargando = false;
  //           }
  //           else {
  //             this._notify.warn('¡Advertencia!', resp.mensajes);
  //             console.warn("postForm", postForm);

  //           }
  //           this.cargando = false;
  //         }, err => {
  //           this._notify.error('¡Error!', 'No ha establecido conexión con el servidor.');
  //           this.cargando = false;
  //           console.warn("postForm", postForm);

  //         });
  //       }
  //       else {
  //         this._notify.warn('¡Advertencia!', "Las claves nuevas no coinciden");
  //       }
  //     }
  //   } catch (error) {
  //     this._notify.error('¡Error!', 'No ha establecido conexión con el servidor.');
  //     this.cargando = false;
  //   }

  // }


  // onlyNumbers(event) {
  //   let keyCode = event['keyCode'] || 0;
  //   if (keyCode < 48 || keyCode > 57) {
  //     event.preventDefault();
  //   }
  // }

readLocalStorageValue(key) {
    return localStorage.getItem(key);
}


}
